import { type ReactNode } from 'react';

interface ConfigTabShellProps {
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  children: ReactNode;
}

/** Loading / error / content wrapper shared by the settings-form config tabs. */
export function ConfigTabShell({ isLoading, isError, onRetry, children }: ConfigTabShellProps) {
  if (isLoading) {
    return (
      <div className="max-w-lg space-y-3">
        {[...Array(3)].map((_, i) => <div key={i} className="h-12 animate-pulse rounded-md bg-muted/60" />)}
      </div>
    );
  }
  if (isError) {
    return (
      <div className="rounded-xl border border-border/60 p-8 text-center text-sm text-muted-foreground">
        Couldn’t load settings. <button className="text-primary underline" onClick={onRetry}>Retry</button>
      </div>
    );
  }
  return <>{children}</>;
}
